import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  attendeeId: localStorage.getItem('attendeeId') || '',
  attendeeSessionGroupID: null,
  sessionId: null,
  dataLoaded: false,
  sessionData: {
    sessionId: null,
    attendeeSessionGroupID: null,
    attendeeId: null,
    questionStatus: null,
    currentQuestionIndex: null,
    sessionQuestions: []
    },
  sessionStatus: null,
  loading: false,
  currentQuestionIndex: null,
  currentStep: null,
  selectedOption: null,
  leaderboardData: null,
  clientConfig: {}
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setAttendeeId: (state, action) => {
      state.attendeeId = action.payload;
      localStorage.setItem('attendeeId', action.payload);
    },
    setSessionData: (state, action) => {
      console.log("Set session Data", action.payload)
      state.sessionData = action.payload.sessionData;
      state.currentQuestionIndex = action.payload.currentQuestionIndex;
      state.attendeeSessionGroupID = action.payload.attendeeSessionGroupID;
      state.sessionQuestions = action.payload.sessionQuestions;
      state.currentStep = action.payload.currentStep;
      state.sessionStatus = action.payload.status;
      state.leaderboardData = action.payload.leaderboardData;
      state.clientConfig = action.payload.clientConfig;
      state.dataLoaded = true;

    },
    setCurrentQuestionAnswered: (state, action) => {
      state.sessionQuestions = state.sessionData.sessionQuestions.map((question, index) => {
        if (index === action.payload.currentQuestionIndex) {
          return {
            ...question,
            answered: action.payload.answered,
          };
        }
        return question;
      })
    },
    setAttendeeGroupId: (state, action) => {
      state.attendeeSessionGroupID = action.payload;
    },
    setQuestionUpdate: (state, action) => {
      state.currentQuestionIndex= action.payload.questionIndex;
      state.currentStep = action.payload.status;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLeaderboardData: (state, action) => {
      state.leaderboardData = action.payload.leaderboardData;
    },
    updateQuestionStep: (state, action) => {
      const { questionIndex, step } = action.payload;

      if (state.sessionData && state.sessionData.allQuestions) {
        // Update the step of the specified question
        state.currentQuestionIndex = questionIndex;
        state.sessionData = {
          ...state.sessionData,
          currentQuestionIndex: questionIndex,
          allQuestions: state.sessionData.allQuestions.map((question, index) => {
            if (index === questionIndex) {
              return {
                ...question,
                step: step,
              };
            }
            return question;
          }),
        };
      }
    },
    setSelectedOptionRedux: (state,action) => {
      state.selectedOption = action.payload;
    },
    setSessionStatus: (state,action) => {
      state.sessionStatus = action.payload;
    },
  },
});

export const { setAttendeeId, setSessionData, setAttendeeGroupId, setQuestionUpdate, setLoading, updateQuestionStep, setCurrentQuestionAnswered, setSelectedOptionRedux, setSessionStatus, setLeaderboardData } = dataSlice.actions;
export default dataSlice.reducer;
